import { render, staticRenderFns } from "./GameOne.vue?vue&type=template&id=2b024781&scoped=true"
import script from "./GameOne.vue?vue&type=script&lang=js"
export * from "./GameOne.vue?vue&type=script&lang=js"
import style0 from "./GameOne.vue?vue&type=style&index=0&id=2b024781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b024781",
  null
  
)

export default component.exports